import { DashboardView } from "../../containers/dashboard/views/DashboardView";
import { ReportsScope } from "../reports/ReportsScope";

// collection of all paths used in the app.
export enum Path {
  MAIN = "/dashboard",
  LOGIN_OIDC_RESPONSE = "/dashboard/login/oidc-response",
  LOGIN = "/dashboard/login",
  LOGIN_WITH_MAGIC_LINK = "/dashboard/login-with-magic-link",
  ROOM = "/dashboard/conversation",
  CALENDAR = "/dashboard/calendar",
  SETTINGS = "/dashboard/settings/settings",
  SETTINGS_PROFILE = "/dashboard/settings/profile",
  SETTINGS_SETTINGS = "/dashboard/settings/settings",
  SETTINGS_BILLING = "/dashboard/settings/billing",
  SETTINGS_USERS = "/dashboard/settings/users",
  SETTINGS_ADVISER_GROUPS = "/dashboard/settings/adviser-groups",
  SETTINGS_ADVISER_STATUSES = "/dashboard/settings/adviser-statuses",
  SETTINGS_ASSIGNMENT_RULES = "/dashboard/settings/assignment-rules",
  SETTINGS_MANUAL_ASSIGNMENT = "/dashboard/settings/manual-assignment",
  SETTINGS_ADVISER_AVATAR = "/dashboard/settings/adviser-avatar",
  SETTINGS_BOTS = "/dashboard/settings/bots",
  SETTINGS_PROACTIVE_MESSAGES = "/dashboard/settings/proactive-messages",
  SETTINGS_TAGGING = "/dashboard/settings/tagging",
  SETTINGS_TAGS = "/dashboard/settings/tags",
  SETTINGS_TAG_GROUPS = "/dashboard/settings/tag-groups",
  SETTINGS_WIDGET = "/dashboard/settings/widget-config",
  SETTINGS_WORKING_HOURS = "/dashboard/settings/working-hours",
  SETTINGS_MESSAGES = "/dashboard/settings/messages",
  SETTINGS_WEBHOOKS = "/dashboard/settings/webhooks",
  SETTINGS_REPORTS = "/dashboard/settings/reports",
  SETTINGS_ROLES = "/dashboard/settings/roles",
  AI_SETTINGS_GENERAL = "/dashboard/ai/settings",
  AI_SETTINGS_MODEL_CONFIGURATION = "/dashboard/ai/model-configuration",
  AI_SETTINGS_TESTING = "/dashboard/ai/testing",
  PASSWORD_RESET = "/dashboard/reset-password",
  ACCEPT_INVITATION = "/dashboard/accept-invitation",
  ORG_SIGNUP = "/dashboard/get-started",
  ORG_SIGNUP_DETAILS = "/dashboard/join-closer",
  REPORTS = "/dashboard/reports"
}

export enum ReportTabs {
  Ai = "ai",
  Sales = "sales",
  Overview = "overview",
  Efficiency = "efficiency",
  ServiceLevelTagGroups = "service-level-tag-groups",
  ServiceLevelTags = "service-level-tags",
  BackLineTags = "back-line-tags",
  AdviserGroups = "adviser-groups",
  TagGroups = "tag-groups",
  Other = "other",
}

export namespace Path {
  export function room(id: string) {
    return `${Path.ROOM}/${id}`;
  }

  export function reports(view: DashboardView, scope: ReportsScope) {
    switch (view) {
      case DashboardView.REPORTS_EFFICIENCY:
        return `${Path.REPORTS}/${scope}/${ReportTabs.Efficiency}`;
      case DashboardView.REPORTS_SERVICE_LEVEL_TAG_GROUPS:
        return `${Path.REPORTS}/${scope}/${ReportTabs.ServiceLevelTagGroups}`;
      case DashboardView.REPORTS_SERVICE_LEVEL_TAGS:
        return `${Path.REPORTS}/${scope}/${ReportTabs.ServiceLevelTags}`;
      case DashboardView.REPORTS_BACK_LINE_TAGS:
        return `${Path.REPORTS}/${scope}/${ReportTabs.BackLineTags}`;
      case DashboardView.REPORTS_ADVISER_GROUPS:
        return `${Path.REPORTS}/${scope}/${ReportTabs.AdviserGroups}`;
      case DashboardView.REPORTS_ADVISER_TAG_GROUPS:
        return `${Path.REPORTS}/${scope}/${ReportTabs.TagGroups}`;
      case DashboardView.REPORTS_OTHER:
        return `${Path.REPORTS}/${scope}/${ReportTabs.Other}`;
      default:
        return Path.LOGIN;
    }
  }
}
